import axios from 'axios'

if (window.location.pathname === '/login') {
  const token = localStorage.getItem('token')
  if (token !== null) {
    localStorage.clear()
  }
}

const defaultConfig = {
}

const getShareToken = () => {
  if (typeof window === 'undefined') return null
  const search = new URLSearchParams(window.location.search)
  return search.get('share')
}

const getConfig = (auth) => {
  if (!auth) {
    return defaultConfig
  }

  return {
    ...defaultConfig,
    headers: {
      ...defaultConfig.headers,
      Authorization: localStorage.getItem('token'),
    },
  }
}

const formatErrorMessage = (status, data) => {
  return data && data.length > 0 && data[0].message || `Error ${status}`
}

const onSuccess = res => {
  return {
    data: (res.status === 200 || res.status === 302) ? res.data : formatErrorMessage(res.status, res.response?.data), headers: res.headers, status: res.status
  }
}
const onError = err => ({ data: null, headers: err.headers, error: { status: err.status } })

axios.interceptors.response.use(response => response, error => {
  if (error.status === 401) {
    localStorage.clear()
    if (window.location.pathname !== '/login') {
      window.location.href = `/login?retpath=${window.location.pathname}`
    }
  } else {
    return error
  }
})

const appendShareTokenToUrl = (url) => {
  const shareToken = getShareToken()
  if (!shareToken) return url
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}share=${encodeURIComponent(shareToken)}`
}

export const get = (url, auth, /** @type { import('axios').AxiosRequestConfig } */ params) => {
  const finalParams = !params ? {} : { ...params }
  const shareToken = getShareToken()
  if (shareToken) {
    finalParams.share = shareToken
  }
  return axios.get(url, { ...getConfig(auth), params: finalParams }).then(onSuccess).catch(onError)
}

export const post = (url, data, auth) =>
  axios.post(appendShareTokenToUrl(url), data, getConfig(auth)).then(onSuccess).catch(onError)

export const postForm = (url, data, auth) =>
  axios.post(appendShareTokenToUrl(url), data, getConfig(auth)).then(onSuccess).catch(onError)

export const put = (url, data, auth) =>
  axios.put(appendShareTokenToUrl(url), data, getConfig(auth)).then(onSuccess).catch(onError)

export const putJSON = (url, data, auth) => {
  const config = getConfig(auth)
  config.headers['Content-Type'] = 'application/json'
  return axios.put(appendShareTokenToUrl(url), data, config).then(onSuccess).catch(onError)
}

export const remove = (url, auth) =>
  axios.delete(appendShareTokenToUrl(url), getConfig(auth)).then(onSuccess).catch(onError)

export const del = (url, auth) => { return axios.delete(appendShareTokenToUrl(url), getConfig(auth)) }

export const file = (url) =>
  axios.get(appendShareTokenToUrl(url), {
    headers: {
      'Accept': 'application/octet-stream',
      'Content-Type': 'application/octet-stream',
      'Authorization': localStorage.getItem('token'),
    },
    responseType: 'blob',
  })
